import React, { useState, useEffect } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import GoogleMap from '../maps/googleMapView'
import Carousel from 'react-bootstrap/Carousel'
import logoPlantSite from '../../images/logo.svg'
import logoHomeSite from '../../images/homesite-logo.svg'
import html2canvas from 'html2canvas'
import * as jsPDF from 'jspdf'
import Axios from 'axios'
import Email from '../../images/icons/correo.svg'

const EstateCardDetails = (props) => {
    const [btnAction, setBtnAction] = useState(null)
    const [mainImage, setMainImage] = useState('')
    const [additionalImages, setAdditionalImages] = useState([])
    const [hostname, setHostname] = useState(null)
    const [email, setEmail] = useState(null)

    const customFields = Object.values(props.data.custom_fields.custom_fields)
    const services = Object.values(props.data.custom_fields.services)

    const Print = () => {
        const input = document.getElementById('property_details')
        const leftColumn = document.getElementById('left-column')
        const rightColumn = document.getElementById('right-column')
        const printBtn = document.getElementById('print-pdf')
        const emailBtn = document.getElementById('email-pdf')
        const closeBtn = document.getElementById('close-btn')
        const h5 = document.getElementsByTagName('h5')
        const rows = document.getElementsByClassName('col-8')

        document.getElementById('working').style.display = 'flex'
        input.classList.add('property-details-print')
        leftColumn.classList.remove('col-lg-6', 'col-md-12')
        rightColumn.classList.remove('col-lg-6', 'col-md-12')
        leftColumn.classList.add('left-column-print')
        rightColumn.classList.add('right-column-print')
        printBtn.hidden = true
        emailBtn.hidden = true
        closeBtn.hidden = true

        for (var i = 0; i < rows.length; i++) {
            if (rows[i].clientHeight === 48) {
                rows[i].style.height = "50px"
            }
            if (rows[i].clientHeight === 72) {
                rows[i].style.height = "75px"
            }

        }
        for (i = 0; i < h5.length; i++) {
            if (h5[i].clientHeight === 26) {
                h5[i].style.height = "25px"
            }
            if (h5[i].clientHeight === 52) {
                h5[i].style.height = "50px"
            }

        }

        html2canvas(input, {
            logging: true,
            useCORS: true,
            scale: 1
        })

            .then((canvas) => {
                var pdf = new jsPDF('l', 'pt', 'letter');
                var pdfHeight = pdf.internal.pageSize.getHeight();
                var pdfWidth = pdf.internal.pageSize.getWidth();

                for (var i = 0; i <= input.clientHeight / 725; i++) {
                    var srcImg = canvas;
                    var sX = 0;
                    var sY = 725 * i; // 725 pixels for every page
                    var sWidth = 1200;
                    var sHeight = 725;
                    var dX = 0;
                    var dY = 0;
                    var dWidth = 1200;
                    var dHeight = 725;

                    window.onePageCanvas = document.createElement("canvas");
                    window.onePageCanvas.setAttribute('width', 1200);
                    window.onePageCanvas.setAttribute('height', 725);
                    var ctx = window.onePageCanvas.getContext('2d');
                    ctx.drawImage(srcImg, sX, sY, sWidth, sHeight, dX, dY, dWidth, dHeight);

                    var canvasDataURL = window.onePageCanvas.toDataURL("image/png", 1.0);

                    //! If we're on anything other than the first page,
                    // add another page
                    if (i > 0) {
                        pdf.addPage(791, 612); //8.5" x 11" in pts (in*72)
                    }
                    //! now we declare that we're working on that page
                    pdf.setPage(i + 1);
                    //! now we add content to that page!
                    pdf.addImage(canvasDataURL, 'PNG', 20, 20, (pdfWidth * .95), (pdfHeight * .93));

                }
                //! after the for loop is finished running, we save the pdf.
                if (btnAction === 'view') {
                    window.open(pdf.output('bloburl'))
                }

                if (btnAction === 'send_email') {
                    Axios.post(props.base_url + 'endpoint/estate', { operation: "send_pdf", pdf: pdf.output('datauristring'), email, hostname, property_name: props.data.title })
                        .then(res => {
                            res.data === 'Invalid email' && alert('El correo parece inválido')
                            res.data !== 'Invalid email' && alert('El correo debería llegar en unos minutos')
                        })
                }


                document.getElementById('working').style.display = 'none'
                input.classList.remove('property-details-print')
                leftColumn.classList.add('col-lg-6', 'col-md-12')
                rightColumn.classList.add('col-lg-6', 'col-md-12')
                leftColumn.classList.remove('left-column-print')
                rightColumn.classList.remove('right-column-print')
                printBtn.hidden = false
                emailBtn.hidden = false
                closeBtn.hidden = false
                for (i = 0; i < rows.length; i++) {
                    rows[i].style.height = "auto"
                }
                for (i = 0; i < h5.length; i++) {
                    h5[i].style.height = "auto"
                }
            }

            )

        setBtnAction(null)
        setEmail(null)
    }

    const HandleHostname = () => {
        window.location.hostname === props.plantsite && setHostname('plantsite')
        window.location.hostname === props.homesite && setHostname('homesite')

    }

    const HandlePrint = () => {
        if (btnAction !== null) {
            if (btnAction === 'send_email') {
                const filledEmail = window.prompt('Ingresa un correo electrónico')
                const confirmation = window.confirm(`¿Estás seguro de que ${filledEmail} es el correo correcto?`)
                !confirmation && setBtnAction(null)
                confirmation && setEmail(filledEmail)
            }
            if (btnAction === 'view') {
                Print()
            }
        }
        else {
            setBtnAction(null)
            return false
        }

    }

    const HandleEmailSent = () => {
        email !== null && Print()
    }


    const MainImage = () => {
        Axios.get(props.base_url + 'endpoint/proxy.php?image=' + props.data.image)
            .then(res => { setMainImage(res.data) })
    }

    const AdditionalImages = () => {
        let old = []
        props.data.thumbnails.map((item) => {
            Axios.get(props.base_url + 'endpoint/proxy.php?image=' + item)
                .then(res => {
                    old = [...old, res.data]
                    setAdditionalImages(old)
                })
            return true
        })


    }

    useEffect(() => {
        HandleHostname()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        HandlePrint()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [btnAction])

    useEffect(() => {
        HandleEmailSent()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [email])


    useEffect(() => {
        MainImage()
        AdditionalImages()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <div id="working" style={{ width: '100%', height: '100vh', position: 'fixed', zIndex: '3', display: 'none', alignItems: 'center', justifyContent: 'center', background: 'white' }}>
                <p>Trabajando, espera por favor...</p>
            </div>
            <Container fluid className="" style={{ background: 'white', minHeight: '100vh' }}>
                <Row id="property_details" className="card-details">
                    <Col xs={12}>
                        <div className="top-bar d-flex justify-content-between align-items-center">
                          <div style={{ marginLeft: 'auto' }}>
                            <button className="btn btn-outline-secondary btn-sm" onClick={props.closeCardDetails}>
                              ← Volver al listado
                            </button>
                          </div>
                        </div>

                        <div className="top-bar" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', cursor: 'pointer', position: 'absolute', right: '0', zIndex: '5', background: 'red', borderRadius: '100%', color: 'white' }}>
                            
                        </div>
                    </Col>
                    <Col md={12} lg={6} style={{ padding: '1rem' }} id="left-column">
                        <div className="detailed-box">
                            <div className="mb-3">
                                <h5>{props.data.title}</h5>
                                <div className="row">
                                    {props.data.transaction !== "" &&
                                        <>
                                            <div className="col-4">Transaccion pretendida:</div>
                                            <div className="col-8">{props.data.transaction}</div>
                                        </>

                                    }
                                </div>
                                <div className="row">
                                    {props.data.asking_price !== "" &&
                                        <>
                                            <div className="col-4">Asking Price:</div>
                                            <div className="col-8">{props.data.asking_price}</div>
                                        </>

                                    }
                                </div>

                                <div className="row">
                                    {props.data.street !== "" &&
                                        <>
                                            <div className="col-4">Calle y número:</div>
                                            <div className="col-8">{props.data.street}</div>
                                        </>

                                    }
                                </div>

                                <div className="row">
                                    {props.data.street_2 !== "" &&
                                        <>
                                            <div className="col-4">Colonia:</div>
                                            <div className="col-8">{props.data.street_2}</div>
                                        </>

                                    }
                                </div>

                                <div className="row">
                                    {props.data.zone !== "" &&
                                        <>
                                            <div className="col-4">Municipio/Alcaldía:</div>
                                            <div className="col-8">{props.data.zone}</div>
                                        </>

                                    }
                                </div>

                                <div className="row">
                                    {props.data.state !== "" &&
                                        <>
                                            <div className="col-4">Estado:</div>
                                            <div className="col-8">{props.data.state}</div>
                                        </>

                                    }
                                </div>


                                {customFields.map((item, index) => (
                                    item.value[0] !== "" &&
                                    <div className="row" key={index}>
                                        <div className="col-4">{item.description}:</div>
                                        <div className="col-8">{item.value}</div>
                                    </div>

                                ))}
                            </div>
                            <div className="mb-3">
                                <h5>Servicios</h5>

                                <div className="row">
                                    {props.data.energy !== "" &&
                                        <>
                                            <div className="col-4">Energía:</div>
                                            <div className="col-8">{props.data.energy}</div>
                                        </>

                                    }
                                </div>

                                <div className="row">
                                    {props.data.water !== "" &&
                                        <>
                                            <div className="col-4">Agua:</div>
                                            <div className="col-8">{props.data.water}</div>
                                        </>

                                    }
                                </div>

                                <div className="row">
                                    {props.data.communications !== "" &&
                                        <>
                                            <div className="col-4">Telecomunicaciones:</div>
                                            <div className="col-8">{props.data.communications}</div>
                                        </>

                                    }
                                </div>

                                <div className="row">
                                    {props.data.natural_gas !== "" &&
                                        <>
                                            <div className="col-4">Gas natural:</div>
                                            <div className="col-8">{props.data.natural_gas}</div>
                                        </>

                                    }
                                </div>

                                {services.map((item, index) => (
                                    item.value[0] !== "" &&
                                    <div className="row" key={index}>
                                        <div className="col-4">{item.description}:</div>
                                        <div className="col-8">{item.value}</div>
                                    </div>

                                ))}
                            </div>
                            <div className="mb-3">
                                <h5>Vecindario</h5>

                                <div className="row">
                                    {props.data.neighbours !== "" &&
                                        <>
                                            <div className="col-4">Vecinos adyacentes y cercanos:</div>
                                            <div className="col-8">{props.data.neighbours}</div>
                                        </>

                                    }
                                </div>

                                <div className="row">
                                    {props.data.surroundings !== "" &&
                                        <>
                                            <div className="col-4">Descripción del entorno:</div>
                                            <div className="col-8">{props.data.surroundings}</div>
                                        </>

                                    }
                                </div>

                                <div className="row">
                                    {props.data.indications !== "" &&
                                        <>
                                            <div className="col-4">Como llegar?:</div>
                                            <div className="col-8">{props.data.indications}</div>
                                        </>

                                    }
                                </div>
                            </div>

                            {/* buttons email and pdf
                            <div className="mb-3 text-center" style={{ display: 'flex', justifyContent: 'center' }}>
                                <div style={{ cursor: 'pointer', display: 'flex', width: '50px', height: '50px', justifyContent: 'center', alignItems: 'center', borderRadius: '100%', fontWeight: '600', color: 'white', background: '#bd2130' }} id="print-pdf" className="mr-1" onClick={() => setBtnAction('view')}>PDF</div>
                                <div style={{ cursor: 'pointer', display: 'flex', width: '50px', height: '50px', justifyContent: 'center', alignItems: 'center', borderRadius: '100%', fontWeight: '600', color: 'white', background: '#343432' }} id="email-pdf" onClick={() => setBtnAction('send_email')}><img src={Email} alt="Enviar por email" style={{ width: '30px' }} /></div>
                            </div> */}


                        </div>

                    </Col>


<Col md={12} lg={6} style={{ padding: '1rem' }} id="right-column">
  {/* Carrusel de imágenes */}
  <div className="mb-4">
    <Carousel
      className="carrousel"
      style={{ maxHeight: '400px', background: '#e0e0e0', overflow: 'hidden', borderRadius: '8px' }}
    >
      <Carousel.Item>
        <img
          crossOrigin="Anonymous"
          style={{ height: '100%', objectFit: 'contain' }}
          className="d-block w-100"
          src={mainImage}
          alt="Thumbnail"
        />
      </Carousel.Item>
      {additionalImages.map((item, index) => (
        <Carousel.Item key={index}>
          <img
            style={{ height: '100%', objectFit: 'contain' }}
            className="d-block w-100"
            src={item}
            alt="Thumbnail"
          />
        </Carousel.Item>
      ))}
    </Carousel>
  </div>

{/* Mapa */}
{props.data.google_map.marker.length > 0 && (
  <div
    className="rounded"
    style={{ maxHeight: '400px', overflow: 'hidden' }}
  >
    <div style={{ height: '400px' }}>
      <GoogleMap
        googleMap={props.data.google_map}
        editable={false}
        draggable={false}
        SetGoogleMap={() => { return }}
      />
    </div>
  </div>
)}
</Col>

                </Row>
            </Container>
        </>
    )
}
export default EstateCardDetails